import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const fetchSubnetworks = () =>
  axios
    .get(Routes.search_subnetworks_path({ format: 'json' }))
    .then(({ data }) => data);

export const useQuerySubnetworks = ({
  defaultData = () => AlumniConnect.currentNetwork?.subnetworks,
  fallbackData = () => [],
  getter = (dataResponse) => dataResponse,
} = {}) => {
  const { data, isSuccess } = useQueryOnce({
    queryKey: ['subnetworks'],
    queryFn: fetchSubnetworks,
  });

  return (isSuccess ? getter(data) : fallbackData()) || defaultData();
};
